/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Step_1Inputs */

const en_svc_research_step_1 = /** @type {(inputs: Svc_Research_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agree the questions, the sources it may use and what a good brief looks like.`)
};

const lv_svc_research_step_1 = /** @type {(inputs: Svc_Research_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vienojamies par jautājumiem, avotiem un to, kā izskatās labs kopsavilkums.`)
};

/**
* | output |
* | --- |
* | "Agree the questions, the sources it may use and what a good brief looks like." |
*
* @param {Svc_Research_Step_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_step_1 = /** @type {((inputs?: Svc_Research_Step_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Step_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_step_1(inputs)
	return en_svc_research_step_1(inputs)
});